/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SampleProjectTemplateSelectionsControllerReplaceActiveMutationRequest, SampleProjectTemplateSelectionsControllerReplaceActiveMutationResponse, SampleProjectTemplateSelectionsControllerReplaceActive401, SampleProjectTemplateSelectionsControllerReplaceActive403 } from "../../models/sampleProjectTemplateSelectionsController/SampleProjectTemplateSelectionsControllerReplaceActive";

function getSampleProjectTemplateSelectionsControllerReplaceActiveUrl() {
  const res = { method: 'PATCH', url: `/api/v1/sample-project-template-selections/active/relationships/projects` as const }  
  return res
}

/**
 * @summary Replace the active sample project templates
 * {@link /api/v1/sample-project-template-selections/active/relationships/projects}
 */
export async function sampleProjectTemplateSelectionsControllerReplaceActive(data: SampleProjectTemplateSelectionsControllerReplaceActiveMutationRequest, config: Partial<RequestConfig<SampleProjectTemplateSelectionsControllerReplaceActiveMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<SampleProjectTemplateSelectionsControllerReplaceActiveMutationResponse, ResponseErrorConfig<SampleProjectTemplateSelectionsControllerReplaceActive401 | SampleProjectTemplateSelectionsControllerReplaceActive403>, SampleProjectTemplateSelectionsControllerReplaceActiveMutationRequest>({ method : "PATCH", url : getSampleProjectTemplateSelectionsControllerReplaceActiveUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}